<p-galleria
  *ngIf="files.length > 0"
  [visible]="visible"
  (visibleChange)="onVisibleChange($event)"
  [value]="files"
  [activeIndex]="activeIndex"
  (activeIndexChange)="onActiveIndexChange($event)"
  [fullScreen]="true"
  showItemNavigators="true"
  [showThumbnailNavigators]="files.length > 4"
  [showThumbnails]="files.length > 1"
  numVisible="4"
>
  <ng-template pTemplate="item" let-file>
    @if ((file | fileType) === 'image') {
      <a [href]="mediaUrl + file.fileName" target="_blank"><img [src]="imageSrc(file)" (error)="onImageError(file)" alt="" class="rg-image" /></a>
    } @else {
      <div class="rg-download-card">
        <fa-icon [icon]="['fal', 'file']" class="rg-download-icon"></fa-icon>
        <p class="rg-download-name">{{ file.fileDisplayName }}</p>
        <a [href]="mediaUrl + file.fileName" target="_blank" [attr.download]="file.fileDisplayName" class="p-button p-button-primary rg-download-btn">
          Click to open/download
        </a>
      </div>
    }
  </ng-template>
  <ng-template pTemplate="thumbnail" let-file>
    @if ((file | fileType) === 'image') {
      <img [src]="thumbnailSrc(file)" (error)="onImageError(file)" alt="" class="rg-thumb" />
    } @else {
      <div class="rg-thumb-file">
        <fa-icon [icon]="['fal', 'file']"></fa-icon>
      </div>
    }
  </ng-template>
</p-galleria>
